// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__CEnsc","selectWrap":"style_selectWrap__1qKVx","priceWrap":"style_priceWrap__2u62k","price":"style_price__-eyhz"};